import { FC } from "react";
import LogoFooter from "../../ui/assets/svg/vviinn-logo-footer.svg";
import { vviinnLinkProps } from "./constants";
import { Styled } from "../../ui/layout";

export const Footer: FC<React.PropsWithChildren<Styled>> = ({ className }) => (
  <footer>
    <a
      {...vviinnLinkProps}
      className={`flex h-10 w-full flex-col items-center justify-center border-t border-stone-200 py-8 dark:border-black dark:bg-stone-950 ${
        className ? className : ""
      }`}
    >
      <img src={LogoFooter} alt="Footer Logo" className="h-4" />
      <p className="mt-1 flex text-center text-sm text-stone-500">
        Let your products find their customers.
      </p>
    </a>
  </footer>
);
